import useProfile from '@/queries/useProfile';
import { setBearerToken } from '@/services/apiService';
import { handleLocalStorage } from '@/utils/handleLocalStorage';
import React, { useEffect } from 'react';
import PreLoading from '../PreLoading';
import { useRouter } from 'next/router';
import useStoreApp from '@/store';

function NormalRoute({ children }: any) {

  const router = useRouter();
  const { from } = router.query as { from: string | null };

  const { status } = useProfile();

  const { isEmbeed, setIsEmbeed } = useStoreApp(state => state.globalSlice);

  const isInvoiceDirectAccess = router.pathname.includes('/invoice') && !!router.query.secretKey;

  if (typeof window !== 'undefined') {
    if (isInvoiceDirectAccess) {
      // skip token setting
    } else if (from === 'hoiango.com') {
      //console.log('clear token when from hoiango.com');
      setBearerToken(null);
    } else {
      setBearerToken(handleLocalStorage.get('accessToken')!);
    }
  }

  useEffect(() => {
    if (isInvoiceDirectAccess) return;

    const isFromEmbeed = from === 'hoiango.com';

    if (isFromEmbeed !== isEmbeed) {
      setIsEmbeed(isFromEmbeed);
      if (typeof window !== 'undefined') {
        //console.log('clear token when from hoiango.com');
        setBearerToken(null);
      }
    }

    if (status === 'loading') return;
  }, [status]);

  if (!isInvoiceDirectAccess && status === 'loading') return <PreLoading />;

  return children;
}

export default NormalRoute;
